module.exports = __webpack_public_path__ + "static/media/statusNegative.faebc196.svg";